import { SarEdit, SarEditPayload } from '~bank-bsa-reporting/types/sar'

export const formToPayloadMapper = (form: SarEdit) => {
  const sarPayload: SarEditPayload = {
    ...form,
    subjectsInfo: form.subjectsInfo.map((el) => ({
      ...el,
      alternateNames: el.alternateNames.map((el) => el.value),
      emails: el.emails.map((el) => el.value),
      websites: el.websites.map((el) => el.value)
    })),
    suspiciousActivityInfo: {
      ...form.suspiciousActivityInfo,
      commodityTypes: form.suspiciousActivityInfo.commodityTypes.map((el) => el.value),
      cusipNumbers: form.suspiciousActivityInfo.cusipNumbers.map((el) => el.value),
      marketsTraded: form.suspiciousActivityInfo.marketsTraded.map((el) => el.value),
      productInstrumentDesc: form.suspiciousActivityInfo.productInstrumentDesc.map((el) => el.value)
    }
  }

  sarPayload.institutionContactInfo.tin = sarPayload.institutionContactInfo.tin.replace('-', '') || ''
  sarPayload.institutionActivitiesInfo.map((el) => {
    el.tin = el?.tin?.replace('-', '') || ''
  })
  sarPayload.subjectsInfo.map((el) => {
    el.tin = el?.tin?.replace('-', '') || ''
  })

  return sarPayload
}

export const payloadToFormMapper = (payload: SarEditPayload) => {
  const sarForm: SarEdit = {
    ...payload,
    subjectsInfo: payload.subjectsInfo.map((el) => ({
      ...el,
      alternateNames: el.alternateNames.map((el) => ({
        value: el
      })),
      emails: el.emails.map((el) => ({
        value: el
      })),
      websites: el.websites.map((el) => ({
        value: el
      }))
    })),
    suspiciousActivityInfo: {
      ...payload.suspiciousActivityInfo,
      commodityTypes: payload.suspiciousActivityInfo.commodityTypes.map((el) => ({
        value: el
      })),
      cusipNumbers: payload.suspiciousActivityInfo.cusipNumbers.map((el) => ({
        value: el
      })),
      marketsTraded: payload.suspiciousActivityInfo.marketsTraded.map((el) => ({
        value: el
      })),
      productInstrumentDesc: payload.suspiciousActivityInfo.productInstrumentDesc.map((el) => ({
        value: el
      }))
    }
  }

  return sarForm
}

export const payloadToFormMapperSubjectInfo = (payload: SarEditPayload['subjectsInfo']) => {
  const sarForm: SarEdit['subjectsInfo'] = [
    ...payload.map((el) => ({
      ...el,
      alternateNames: el.alternateNames.map((el) => ({
        value: el
      })),
      emails: el.emails.map((el) => ({
        value: el
      })),
      websites: el.websites.map((el) => ({
        value: el
      }))
    }))
  ]

  return sarForm
}
